import moment from 'moment-timezone'
import { Action, Reducer } from 'redux'
import { SCHEDULE_STOPS_ACTION_TYPES } from 'utils/actions/facility'
import { AUTO_CONFIRM_ACTION_TYPES } from 'utils/actions/shipmentStop'
import { APPOINTMENT_REFERENCE_ACTION_TYPES } from 'apps/schedule/utils/actions/confirmReference'
import { FORMATS } from 'constants/datetime'
import { IScheduleState, IStop } from '../types/stops'

const {
  SCHEDULE_STOPS_FAILURE,
  SCHEDULE_STOPS_REQUEST,
  SCHEDULE_STOPS_SUCCESS,
} = SCHEDULE_STOPS_ACTION_TYPES

const {
  AUTO_CONFIRM_FAILURE,
  AUTO_CONFIRM_REQUEST,
  AUTO_CONFIRM_SUCCESS,
} = AUTO_CONFIRM_ACTION_TYPES

const {
  APPOINTMENT_REFERENCE_FAILURE,
  APPOINTMENT_REFERENCE_REQUEST,
  APPOINTMENT_REFERENCE_SUCCESS,
} = APPOINTMENT_REFERENCE_ACTION_TYPES

const defaultState = {
  stops: {},
  loading: false,
  errors: undefined,
  submitting: false,
  confirmSuccess: false,
  loadedSchedule: false,
}

interface TStopsReducerAction extends Action<string> {
  payload: {
    id?: string | number
    startAtTime?: string | null
    endAtTime?: string | null
    confirmationReference?: string | null
    stops: {
      mainStop: IStop
      otherStops: IStop[]
    }
  }
  error?: Error
}

const stopsReducer: Reducer<IScheduleState, TStopsReducerAction> = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case SCHEDULE_STOPS_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case SCHEDULE_STOPS_SUCCESS:
      // Because this will overwrite the stops object, we can inspect it
      // later to know if SCHEDULE_STOPS returned the "old" data shape
      // or the "new" one.
      return {
        ...state,
        stops: action.payload.stops,
        loading: false,
        loadedSchedule: true,
      }
    case SCHEDULE_STOPS_FAILURE:
      return {
        ...state,
        errors: action.error,
        loading: false,
        loadedSchedule: true,
      }
    case AUTO_CONFIRM_REQUEST:
    case APPOINTMENT_REFERENCE_REQUEST:
      return {
        ...state,
        submitting: true,
      }
    case AUTO_CONFIRM_SUCCESS: {
      let { mainStop } = state.stops

      if (mainStop?.stopId === action.payload.id) {
        mainStop = {
          ...mainStop,
          confirmed: true,
          startAtTime: moment.utc(action.payload.startAtTime).format(FORMATS.militaryTimeFormat),
          endAtTime: moment.utc(action.payload.endAtTime).format(FORMATS.militaryTimeFormat),
        }
      }

      return {
        ...state,
        stops: {
          mainStop,
          otherStops: state.stops.otherStops?.map(stop => {
            if (stop.stopId === action.payload.id) {
              return {
                ...stop,
                confirmed: true,
                startAtTime: moment
                  .utc(action.payload.startAtTime)
                  .format(FORMATS.militaryTimeFormat),
                endAtTime: moment.utc(action.payload.endAtTime).format(FORMATS.militaryTimeFormat),
              }
            }
            return stop
          }),
        },
        submitting: false,
      }
    }
    case APPOINTMENT_REFERENCE_SUCCESS: {
      let { mainStop } = state.stops

      if (mainStop?.stopId === action.payload.id) {
        mainStop = {
          ...mainStop,
          confirmationReference: action.payload.confirmationReference,
        }
      }

      return {
        ...state,
        stops: {
          mainStop,
          otherStops: state.stops.otherStops?.map(stop => {
            if (stop.stopId === action.payload.id) {
              return {
                ...stop,
                confirmationReference: action.payload.confirmationReference,
              }
            }
            return stop
          }),
        },
        submitting: false,
        confirmSuccess: true,
      }
    }
    case APPOINTMENT_REFERENCE_FAILURE:
    case AUTO_CONFIRM_FAILURE:
      return {
        ...state,
        errors: action.error,
        submitting: false,
      }
    default:
      return state
  }
}

export default stopsReducer
